import { CookieService } from '@app/services';

export class CookiesComponent {
    private static CONSENT_PROPERTY_NAME = `nordita_consent`;

    constructor() {
        const consentPopup = document.getElementById('cookies-consent-popup');
        const consentButton = document.querySelector('#cookies-consent-button');
        const cookieService = new CookieService();

        if (consentButton) {
            consentButton.addEventListener('click', () => {
                cookieService.set(CookiesComponent.CONSENT_PROPERTY_NAME, 'true');
                consentPopup.classList.add('hidden');
            });
        }

        if (consentPopup && cookieService.get(CookiesComponent.CONSENT_PROPERTY_NAME) !== 'true') {
            consentPopup.classList.remove('hidden');
        }
    }
}
